<template>
  <short-link-view target-page="dashboard" />
</template>

<script>
import ShortLinkView from '../components/Common/ShortLinkView.vue';

export default {
  components: { ShortLinkView }
};
</script>
